import { getStatusColor } from "./statusColor";

export default function MerdeIcon({
  status,
  size = 24,
  className,
}) {
  const color = getStatusColor(status);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 500 500"
      style={{ display: "block" }}
      className={className}
    >
      {/* YTTERSTE RING – HVIT */}
      <circle
        cx="250"
        cy="250"
        r="235"
        fill="#ffffff"
        opacity="0.35"
      />

      {/* MIDTRE RING */}
      <circle
        cx="250"
        cy="250"
        r="205"
        fill={color}
        opacity="0.45"
      />

      {/* INDRE SIRKEL */}
      <circle
        cx="250"
        cy="250"
        r="180"
        fill={color}
        opacity="0.75"
      />
    </svg>
  );
}
